import React, { useEffect, useState, Fragment } from 'react';
import { ClockIcon } from 'lucide-react';
import { COUNTDOWN_SECONDS } from '../config';
function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(COUNTDOWN_SECONDS);
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(prev => prev <= 1 ? COUNTDOWN_SECONDS : prev - 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    label: 'Horas',
    value: pad(hours)
  }, {
    label: 'Min',
    value: pad(minutes)
  }, {
    label: 'Seg',
    value: pad(seconds)
  }];
  return <div className="flex flex-col items-center gap-2" data-id="element-62">
      <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-brand-pink" data-id="element-63">
        <ClockIcon className="h-4 w-4" data-id="element-64" />
        La oferta termina en
      </div>
      <div className="flex items-center gap-2" data-id="element-65">
        {units.map((u, i) => <Fragment key={u.label} data-id="element-66">
            <div className="flex min-w-[58px] flex-col items-center rounded-xl bg-brand-purpleDark px-2 py-2 shadow-md" data-id="element-67">
              <span className="font-display text-2xl font-extrabold tabular-nums text-white sm:text-3xl" data-id="element-68">
                {u.value}
              </span>
              <span className="text-[10px] font-bold uppercase tracking-wider text-white/60" data-id="element-69">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className="font-display text-2xl font-extrabold text-brand-purpleDark" data-id="element-70">
                :
              </span>}
          </Fragment>)}
      </div>
    </div>;
}